/**
 * Olark Chat API
 */

// tslint:disable-next-line:no-string-literal
const olark = window['olark'];

function show() {
  olark('api.box.show');
}

function hide() {
  olark('api.box.hide');
}

function expand() {
  olark('api.box.expand');
}

export default {
  expand,
  hide,
  show,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/olark.ts